
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/map",
      function () {
        return require("private-next-pages/search/map/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/map"])
      });
    }
  